import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { completeDeliveryApi } from './completeDelivery.api'
import completeDeliveryInitialState from './completeDelivery.initialState'
import { CompleteDeliveryErrorResponse, CompleteDeliveryRequestPayload } from './completeDelivery.types'

export const completeDelivery = createAsyncThunk(
  urls.fulfillmentOrders.completeDelivery,
  async (payload: CompleteDeliveryRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await completeDeliveryApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const completeDeliverySlice = createSlice({
  name: urls.fulfillmentOrders.completeDelivery,
  initialState: completeDeliveryInitialState,
  reducers: {
    resetCompleteDelivery: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(completeDelivery.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(completeDelivery.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(completeDelivery.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as CompleteDeliveryErrorResponse
        state.success = null
      })
  }
})

export const { actions: completeDeliveryActions, reducer: completeDeliveryReducer } = completeDeliverySlice
export const { resetCompleteDelivery } = completeDeliveryActions
export default completeDeliverySlice.reducer
